import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { FragranceService } from '~/service/service.fragrance';
import { UIService } from '~/service/service.ui';
import { useService } from '~/shared/service/service.base';
import { Text } from '../view.box';

export const FragrancesFTSDialog = observer(() => {
	const [fragrances, ui] = useService(FragranceService, UIService);

	const handleConfirm = useCallback(async () => {
		ui.hideDialog();
		fragrances.recalculateFTS();
	}, [fragrances, ui]);

	return (
		<Dialog open={ui.dialog === FragrancesFTSDialog} onClose={ui.hideDialog} maxWidth="md">
			<DialogTitle>Recalculate Fragrance FTS tokens</DialogTitle>
			<DialogContent>
				<Text>
					This action will recalculate fragrance FTS tokens for all fragrances. This is necessary after after
					significant changes to fragrance data.
				</Text>
				<br />
				<Text color="error.main" fontWeight="bold">
					Depending on the number of fragrances, this may take some time.
				</Text>
				<Text color="error.main" fontWeight="bold">
					Are you sure you want to proceed?
				</Text>
			</DialogContent>
			<DialogActions>
				<Button onClick={ui.hideDialog}>Cancel</Button>
				<Button color="primary" variant="contained" onClick={handleConfirm}>
					Confirm
				</Button>
			</DialogActions>
		</Dialog>
	);
});
